<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{categoryName[defaultLang] || categoryName}} &#8250; {{collectionItemName[defaultLang] || ''}}</h2>
      <div class="mb15">
        <div class="innerTitle setLabel">{{locale.image}}</div>
        <p class="sysMessage">{{ locale.message_collection_detail_images }}</p>
        <draggable
          v-model="imageList"
          group="imageList"
          animation="300"
          class="imgList">
          <div
            v-for="(img, index) in imageList"
            :key="index"
            class="imgItem"
            :style="{backgroundImage: `url(${img})`}">
            <span v-if="index === 0" class="stkr">{{ locale.daepyo }}</span>
            <button type="button" class="btnDel" @click="delImg(index)"></button>
          </div>
          <label v-if="imageList.length <= imgLimit" class="imgItem addImg"><input type="file" @change="uploadImage($event)"></label>
        </draggable>
      </div>
      <div class="flexBox info mb15">
        <div class="flexInner">
          <div class="label groupLabel mb15">{{ locale.basic_info }}</div>
          <div class="mb15">
            <div class="innerTitle setLabel">{{locale.name}}</div>
            <SetLanguageValue
              :locale="locale"
              :langValue="collectionItemName"
              :textarea="true" />
          </div>
          <div class="mb15">
            <div class="innerTitle setLabel">{{locale.descTop}}</div>
            <SetLanguageValue
              :locale="locale"
              :langValue="descTop"
              :textarea="true" />
          </div>
          <div class="mb15">
            <div class="innerTitle setLabel">{{ locale.descBottom }}</div>
            <SetLanguageValue
              :locale="locale"
              :langValue="descBottom"
              :textarea="true" />
          </div>
          <div class="mb15">
            <div class="innerTitle setLabel">{{locale.category}}</div>
            <button type="button" class="btn btnWhite" @click="setCategory = true">{{ locale.setting }}</button>
          </div>
        </div>
        <div class="flexInner" data-flex="2">
          <div class="label groupLabel mb15">{{ locale.settings_detail_page }}</div>
          <div class="mb15">
            <div class="innerTitle setLabel">{{ locale.use_detail_page }}</div>
            <span class="checkbox">
              <input type="checkbox" id="detail_active" v-model="detailActive" />
              <label for="detail_active">{{locale.activate}}</label>
            </span>
          </div>
          <div v-if="detailActive" class="mb15">
            <div class="innerTitle setLabel">{{ locale.detail_page_type }}</div>
            <div class="detailType">
              <span class="checkbox"
                v-for="t in detailTypes"
                :key=t
                :class="{isActive: detailType === t}">
                <input type="radio" :id="`detail_type_${t}`" :value="t" v-model="detailType" />
                <label :for="`detail_type_${t}`">{{ locale[`layout_type_${t}`] }}</label>
                <div class="mt5 img">
                  <img :src="require(`@/assets/img/img_pagetype_${t}.png`)" alt="">
                </div>
              </span>
            </div>
            <div v-if="detailType === 'embed'" class="mt5">
              <div class="innerTitle setLabel">{{ locale.embed_url }}</div>
              <p class="sysMessage">{{ locale.message_embed_url }}</p>
              <input type="text" class="input" placeholder="https://" v-model="embed">
            </div>
          </div>
          <div v-if="detailActive" class="mb30">
            <div class="innerTitle setLabel">{{ locale.settings_detail_page_color }}</div>
            <span class="checkbox">
              <input type="checkbox" id="detail_color_active" v-model="detailColorActive" />
              <label for="detail_color_active">{{locale.activate}}</label>
            </span>
          </div>
          <div v-if="detailActive && detailColorActive" class="flexBox mb30">
            <div class="flexInner">
              <div class="innerTitle setLabel">{{ locale.detail_page_background }}</div>
              <div class="mt5">
                <ColorPicker
                  :target="'detailBackgroundColor'"
                  :color="detailBackgroundColor"
                  :useColorOnly="true"
                  @changeColor="changeColor" />
              </div>
            </div>
            <div class="flexInner">
              <div class="innerTitle setLabel">{{ locale.detail_page_text }}</div>
              <div class="mt5">
                <ColorPicker
                  :target="'detailTextColor'"
                  :color="detailTextColor"
                  :useColorOnly="true"
                  @changeColor="changeColor" />
              </div>
            </div>
          </div>
          <div v-if="detailActive && (detailType === 'horisontal' || detailType === 'vertical')">
            <div class="flexBox mb15">
              <div class="flexInner">
                <div class="innerTitle setLabel">{{ locale.detail_page_margin }}</div>
                <InputRange
                  :min="1"
                  :max="5"
                  :step="1"
                  :minLabel="locale.none"
                  :maxLabel="locale.wide"
                  :value="detailPadding"
                  @setRange="setRange('detailPadding', $event)" />
              </div>
              <div class="flexInner"></div>
            </div>
            <div class="flexBox mb15">
              <div class="flexInner">
                <div class="innerTitle setLabel">{{ locale.detail_page_column_ratio }}</div>
                <div>
                  <span v-for="(d, index) in detailRatio"
                    :key="index"
                    class="mr5">
                    <input type="text" class="input sizeS" v-model="detailRatio[index]">
                  </span>
                </div>
              </div>
              <div class="flexInner">
                <div class="innerTitle setLabel">{{ locale.detail_page_image_ratio }}</div>
                <div>
                  <input type="text" class="input sizeS" v-model="detailImageRatio.width"> :
                  <input type="text" class="input sizeS" v-model="detailImageRatio.height">
                </div>
              </div>
            </div>
            <div class="mb15">
              <div class="innerTitle setLabel">{{ locale.font_size }}</div>
              <div class="flexBox">
                <div class="flexInner">
                  <label class="colorGrey mr5">{{ locale.name }}</label>
                  <div class="unitInput mr15">
                    <input type="text" class="input" v-model="fontSize.collectionItemName">
                    <span class="unit">px</span>
                  </div>
                </div>
                <div class="flexInner">
                  <label class="colorGrey mr5">{{ locale.descTop }}</label>
                  <div class="unitInput mr15">
                    <input type="text" class="input" v-model="fontSize.descTop">
                    <span class="unit">px</span>
                  </div>
                </div>
                <div class="flexInner">
                  <label class="colorGrey mr5">{{ locale.descBottom }}</label>
                  <div class="unitInput mr15">
                    <input type="text" class="input" v-model="fontSize.descBottom">
                    <span class="unit">px</span>
                  </div>
                </div>
                <div class="flexInner" data-flex="3"></div>
              </div>
            </div>
            <div>
              <div class="innerTitle setLabel">{{ locale.display }}</div>
              <span class="checkbox mr15"
                v-for="d in displays"
                :key=d>
                <input type="checkbox" name="display_items" :id="`display_items_${d}`" :value="d" v-model="display" />
                <label :for="`display_items_${d}`">{{ locale[d] }}</label>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="btns">
        <button v-if="collectionItemId !== 'new'" type="button" class="btn btnRed btnLeft btnAuto" @click="delItem">{{ locale.delete }}</button>
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" @click.stop="save">{{locale.save}}</button>
      </div>
    </div>
    <Category v-if="setCategory"
      :locale="locale"
      :collectionItemId="collectionItemId"
      :checked="category"
      :checkLimit="categoryLimit"
      @close="setCategory = false"
      @changeCheckedItem="setItemCategory" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import draggable from 'vuedraggable'
import ColorPicker from '@/components/Util/ColorPicker'
import SetLanguageValue from '@/components/Util/SetLanguageValue'
import InputRange from '@/components/Util/InputRange'
import Category from './Category'

export default {
  name: 'PageItemDetail',
  props: [
    'locale',
    'collectionItemId',
    'categoryId',
    'defaultLang'
  ],
  components: {
    draggable,
    ColorPicker,
    SetLanguageValue,
    InputRange,
    Category
  },
  computed: {
    pageId () {
      return this.$route.params.pageId
    },
    categoryName () {
      return this.$store.getters['collection/getCategoryNameById'](this.categoryId) || this.categoryId
    }
  },
  created () {
    this.init()
  },
  mounted () {
  },
  data () {
    return {
      imgLimit: 11,
      categoryLimit: 1, // 지정가능한 카테고리 개수
      setCategory: false,
      detailTypes: [
        'horisontal',
        'vertical',
        'gallery',
        'embed'
      ],
      displays: [
        'image',
        'name',
        'descTop',
        'descBottom'
      ],
      collectionItemName: LANG.valueObj(''),
      descTop: LANG.valueObj(''),
      descBottom: LANG.valueObj(''),
      category: [],
      imageList: [],
      detailActive: true,
      detailType: 'horisontal',
      detailColorActive: false,
      detailBackgroundColor: 'rgba(255,255,255,1)',
      detailTextColor: 'rgba(30,30,30,1)',
      detailPadding: '3',
      embed: '',
      detailRatio: ['1', '1'],
      detailImageRatio: {
        width: '3',
        height: '2'
      },
      fontSize: {
        collectionItemName: '24',
        descTop: '16',
        descBottom: '16'
      },
      display: [
        'image',
        'name',
        'descTop',
        'descBottom'
      ]
    }
  },
  methods: {
    async init () {
      if (this.collectionItemId === 'new' && this.categoryId) {
        this.category = [this.categoryId]
      }
      if (this.collectionItemId !== 'new') {
        await this.getCollectionItem()
      }
    },
    // 아이템 호출
    async getCollectionItem () {
      const data = {
        pageId: this.pageId,
        collectionItemId: this.collectionItemId
      }
      this.$store.commit('onLoading', true)
      const res = await this.$store.dispatch('collection/getCollectionItem', data)
      const detail = res?.message
      if (detail) {
        this.collectionItemName = detail.collectionItemName
        this.category = detail.category?.map(x => x.categoryId) || [this.categoryId]
        this.descTop = detail.attribute.descTop
        this.descBottom = detail.attribute.descBottom
        this.imageList = detail.attribute.imageList || []
        this.detailActive = detail.attribute.detailActive
        this.detailType = detail.attribute.detailType
        this.detailColorActive = detail.attribute.detailColorActive
        this.detailBackgroundColor = detail.attribute.detailBackgroundColor
        this.detailTextColor = detail.attribute.detailTextColor || 'rgba(30,30,30,1)'
        this.detailPadding = detail.attribute.detailPadding
        this.embed = detail.attribute.embed
        this.detailRatio = detail.attribute.detailRatio
        this.detailImageRatio = detail.attribute.detailImageRatio
        this.fontSize = detail.attribute.fontSize
        this.display = detail.attribute.display
      } else {
        alert(this.locale.system_error)
      }
      this.$store.commit('onLoading', false)
    },
    uploadImage (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.imageList.push(res.source)
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    delImg (index) {
      this.imageList = this.imageList.filter((x, i) => i !== index)
    },
    changeColor (data) {
      this[data.target] = data.color
    },
    setRange (target, value) {
      this[target] = `${value}`
    },
    setItemCategory (categoryId) {
      if (this.categoryLimit === 1) { // radio형식의 체크
        this.category = [categoryId]
      } else { // checkbox형식의 체크
        const index = this.category.indexOf(categoryId)
        if (index === -1) {
          this.category.push(id) // 없으면 추가
        } else {
          this.category.splice(index, 1) // 있으면 제거
        }
      }
    },
    async delItem () {
      const data = {
        pageId: this.pageId,
        collectionItemId: this.collectionItemId
      }
      if (window.confirm(this.locale.confirm_delete)) {
        this.$store.commit('onLoading', true)
        const res = await this.$store.dispatch('collection/deleteCollectionItem', data)
        if (res?.status === 200) {
          alert(this.locale.complete_delete)
          this.$emit('completeDelete')
          this.$emit('close')
        }
        this.$store.commit('onLoading', false)
      }
    },
    async save () {
      const data = {
        pageId: this.pageId,
        collectionItemId: this.collectionItemId === 'new' ? UNIQUE.uniqueId8() : this.collectionItemId,
        collectionItemName: this.$store.getters['util/filteredLanguageValues'](this.collectionItemName),
        category: this.category,
        collectionCategory: this.collectionCategory || '',
        attribute: {
          imageList: this.imageList,
          descTop: this.$store.getters['util/filteredLanguageValues'](this.descTop),
          descBottom: this.$store.getters['util/filteredLanguageValues'](this.descBottom),
          detailActive: this.detailActive,
          detailColorActive: this.detailColorActive,
          detailBackgroundColor: this.detailBackgroundColor,
          detailTextColor: this.detailTextColor,
          detailType: this.detailType,
          detailPadding: this.detailPadding,
          embed: this.embed,
          detailRatio: this.detailRatio,
          detailImageRatio: this.detailImageRatio,
          fontSize: this.fontSize,
          display: this.display
        }
      }
      const func = this.collectionItemId === 'new'
        ? 'collection/createCollectionItem'
        : 'collection/updateCollectionItem'
      if (window.confirm(this.locale.confirm_save)) {
        this.$store.commit('onLoading', true)
        const res = await this.$store.dispatch(func, data)
        if (res?.status === 200) {
          alert(this.locale.complete_save)
          this.$emit('completeSave', data.collectionItemId)
          this.$emit('close')
        }
        this.$store.commit('onLoading', false)
      }
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 900px;
  }
  .info {
    overflow: auto;
  }
}
.imgList {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 4px;
  .imgItem {
    position: relative;
    height: 0;
    padding-top: 74%;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    overflow: hidden;
    background-color: $color-white;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .stkr {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 4px;
    font-size: 12px;
    color: $color-white;
    background-color: $color-primary;
  }
  .btnDel {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    background: $color-white url('~@/assets/img/ico_close_black.svg') 50% 50% / 16px no-repeat;
    opacity: 0.6;
  }
  .addImg {
    border-style: dashed;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/ico_plus.svg') 50% 50% / 16px no-repeat;
      opacity: 0.2;
    }
  }
}
.detailType {
  display: flex;
  flex-wrap: wrap;
  .checkbox {
    flex: 1;
    margin: 0 0 10px;
  }
  .img {
    width: 118px;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    overflow: hidden;
  }
  .isActive {
    .img {
      border-color: $color-grey;
    }
  }
}
.halfBox {
  max-width: 50%;
}
</style>
